// Third Party
import * as React from 'react';

// Utils
import { findIndex } from 'lodash';
import { PropertyType } from '@gql';

// UI
import { PropertySelectionCard } from './property-type-selection/property-selection-card';

type Props = {
  allPropertyTypes: PropertyType[];
  currentPropertyTypes: PropertyType[];
  togglePropertyTypeFilter: (propertyType: PropertyType) => void;
};

export const PropertyTypeSelection: React.FC<Props> = ({
  allPropertyTypes,
  currentPropertyTypes,
  togglePropertyTypeFilter,
}) => {
  return (
    <div className="mt-4 grid grid-cols-3 md:grid-cols-5 gap-2 sm:gap-4">
      {allPropertyTypes.map((propertyType, _) => {
        const active =
          findIndex(
            currentPropertyTypes,
            (o: PropertyType) => o === propertyType
          ) > -1;
        return (
          <PropertySelectionCard
            key={propertyType}
            propertyType={propertyType}
            selected={active}
            onClick={() => togglePropertyTypeFilter(propertyType)}
          />
        );
      })}
    </div>
  );
};
